import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    // Calculate time until next midnight
    const calculateTimeLeft = () => {
      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setHours(24, 0, 0, 0);
      const diff = tomorrow.getTime() - now.getTime();
      const h = Math.floor(diff / (1000 * 60 * 60) % 24);
      const m = Math.floor(diff / 1000 / 60 % 60);
      const s = Math.floor(diff / 1000 % 60);
      setTimeLeft({
        hours: h,
        minutes: m,
        seconds: s
      });
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (num: number) => num.toString().padStart(2, '0');
  return <div className="bg-[#0F1F3D] border border-white/5 rounded-2xl p-6 md:p-8 text-center max-w-2xl mx-auto mb-10 shadow-2xl relative overflow-hidden" data-id="element-75">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-red-500 to-transparent" data-id="element-76"></div>
      <p className="text-red-500 font-bold text-xs md:text-sm uppercase tracking-widest mb-4" data-id="element-77">
        ⏰ Esta oferta termina en:
      </p>
      <div className="flex justify-center items-center gap-3 md:gap-6 text-4xl md:text-6xl font-anton text-white" data-id="element-78">
        <div className="flex flex-col items-center w-16 md:w-24" data-id="element-79">
          <span data-id="element-80">{pad(timeLeft.hours)}</span>
          <span className="text-[10px] md:text-xs font-sans text-gray-400 uppercase tracking-wider mt-1 font-bold" data-id="element-81">
            Horas
          </span>
        </div>
        <span className="text-gray-600 pb-5 md:pb-6" data-id="element-82">:</span>
        <div className="flex flex-col items-center w-16 md:w-24" data-id="element-83">
          <span data-id="element-84">{pad(timeLeft.minutes)}</span>
          <span className="text-[10px] md:text-xs font-sans text-gray-400 uppercase tracking-wider mt-1 font-bold" data-id="element-85">
            Min
          </span>
        </div>
        <span className="text-gray-600 pb-5 md:pb-6" data-id="element-86">:</span>
        <div className="flex flex-col items-center w-16 md:w-24" data-id="element-87">
          <span data-id="element-88">{pad(timeLeft.seconds)}</span>
          <span className="text-[10px] md:text-xs font-sans text-gray-400 uppercase tracking-wider mt-1 font-bold" data-id="element-89">
            Seg
          </span>
        </div>
      </div>
      <div className="w-full max-w-md mx-auto bg-[#0A1628] h-1.5 rounded-full mt-6 overflow-hidden" data-id="element-90">
        <div className="bg-red-500 h-full w-[85%] rounded-full animate-pulse" data-id="element-91"></div>
      </div>
    </div>;
}